import React from 'react';
import Skeleton from '@material-ui/lab/Skeleton';
import PropTypes from 'prop-types';

import { Title, Avatar, Tag, ContainedButton, GridContainer, GridItem, FileIcon } from '../index';

import { StyledCard } from './style';

export const ProviderInfoCard = ({ data, mobileS, ...rest }) => {
    return (
        <StyledCard
            {...rest}
            variant="outlined"
            padding="4px 10px"
            style={{
                marginTop: '10px',
            }}
        >
            <div style={{ display: 'flex', alignItems: 'center' }}>
                {data ? (
                    <Avatar
                        alt={data?.user?.fullname}
                        src={data?.user?.avatar ? data?.user?.avatar?.url : null}
                        $avatarSize="64px"
                    />
                ) : (
                    <Skeleton component="div" variant="rect" width="64px" height="64px" />
                )}
                <div style={{ display: 'flex', flexGrow: 1 }}>
                    <GridContainer style={{ paddingLeft: mobileS ? '5px' : '10px' }} spacing={2}>
                        <GridItem justifyContent="flex-start">
                            {data ? (
                                <Title style={{ fontSize: '16px' }}>{data?.user?.fullname}</Title>
                            ) : (
                                <Skeleton width={150} height={30} variant="text" />
                            )}
                        </GridItem>
                        <GridItem
                            justifyContent="flex-start"
                            style={{ display: 'flex', columnGap: '5px' }}
                        >
                            {data?.specialist?.slice(0, 2).map((tag, index) => (
                                <Tag key={`specialist${index}`}>{tag}</Tag>
                            ))}
                        </GridItem>
                    </GridContainer>
                </div>
                <div>
                    {/* <ContainedButton
                        $icon
                        onClick={() => console.log('go to session')}
                        disabled={!data}
                    >
                        <FileIcon />
                    </ContainedButton> */}
                </div>
            </div>
        </StyledCard>
    );
};

ProviderInfoCard.propTypes = {
    data: PropTypes.object,
    mobileS: PropTypes.bool,
    rest: PropTypes.object,
};
